export default "__VITE_ASSET__DnZO7pdQ__"